<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <span>货转日期：</span>
            <el-date-picker size="mini" label="日期" @change="refetchData" v-model="date" type="daterange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

            <el-input class="margin-l" style="width: 400px;" size="mini" placeholder="库区、卖方、转出、转入、编号、备注搜索" clearable
                @clear="refetchData" prefix-icon="el-icon-search" v-model="keyword"
                @keyup.native.enter="refetchData"></el-input>
            <el-button class="margin-l" size="mini" type="primary" @click.stop="refetchData">搜索</el-button>
        </div>

        <div class="line-container block-mini-top">
            <el-button size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
            <el-button size="mini" type="warning" :loading="deleting" @click.stop="changeStatus()">批量标记过期</el-button>
            <el-button size="mini" type="primary" :loading="downloading" @click.stop="allDownload()">一键下载</el-button>
            <router-link :to="'/html-pdfpreview'" class="margin-l" target="_blank">
                <el-button size="mini" type="primary">多图合成PDF</el-button>
            </router-link>
        </div>

        <paged-table ref="table" @fetch-data="fetchData" class="block-top">
            <el-table slot show-summary :sum-text="sumText" :data="data" border stripe size="mini"
                :cell-style="$parent.cellStyle" ref="multipleTable" @selection-change="handleSelectionChange"
                @row-click="selectRow">
                <el-table-column type="selection" fixed align="center" width="45"></el-table-column>
                <el-table-column type="index" fixed align="center" width="45"></el-table-column>
                <el-table-column label="下家承担日期" align="center" width="110">
                    <template slot-scope="scope" v-if="scope.row.downDate">
                        {{scope.row.downDate|fmt-date}}
                    </template>
                </el-table-column>
                <el-table-column label="库区" align="center" width="200">
                    <template slot-scope="scope" v-if="scope.row.house">
                        {{scope.row.house.name}}
                    </template>
                </el-table-column>
                <el-table-column label="编号" align="center" width="150">
                    <template slot-scope="scope">
                        {{scope.row.orderNO}}
                    </template>
                </el-table-column>
                <el-table-column label="卖方" align="center" width="220">
                    <template slot-scope="scope">
                        <template v-if="scope.row.house && scope.row.house.name == '太仓阳鸿石化有限公司'">
                            /
                        </template>
                        <template v-else-if="scope.row.purchaser0">
                            {{scope.row.purchaser0.name}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="转出方" align="center" width="220">
                    <template slot-scope="scope" v-if="scope.row.purchaser1">
                        {{scope.row.purchaser1.name}}
                    </template>
                </el-table-column>
                <el-table-column label="转入方" align="center" width="220">
                    <template slot-scope="scope" v-if="scope.row.purchaser2">
                        {{scope.row.purchaser2.name}}
                    </template>
                </el-table-column>
                <el-table-column label="备注" align="center" width="100">
                    <template slot-scope="scope">
                        {{scope.row.remarks}}
                    </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right" min-width="180">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button class="super-mini-button" type="danger" size="mini"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                        <router-link :to="goYulan(scope.row)" class="margin-l" target="_blank">
                            <el-button class="super-mini-button" type="success" size="mini">预览</el-button>
                        </router-link>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-forward ref="edit" @fetch-data="fetchData"></dialog-edit-forward>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import DialogEditForward from "../components/dialog/dialogEditForward";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";
import dayjs from "dayjs";
import { baseUrl } from "../util/http";

export default {
    components: {
        DialogEditForward,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            date: [],
            multipleSelection: [],
            downloading: false,
            deleting: false,
            baseUrl,
        };
    },
    created() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
        sumText() {
            return `${this.multipleSelection.length}`;
        },
    },
    mounted() {},
    methods: {
        upload2Pdf() {},
        selectRow(row, event, column) {
            this.toggleSelection(row);
        },
        toggleSelection(row) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async changeStatus() {
            if (!this.multipleSelection.length)
                return this.$message.error("请至少选择一条货转单！");
            await actionConfirm();
            this.deleting = true;
            let list = this.multipleSelection;
            let lines = [];
            for (let index = 0; index < list.length; index++) {
                let item = list[index];
                lines.push(item._id);
            }
            let res = await HttpClient.post("/forward/changestatus", {
                lines,
                status: "finish",
            });
            this.deleting = false;
            this.refetchData();
        },
        async allDownload() {
            if (!this.multipleSelection.length)
                return this.$message.error("请至少选择一条货转单！");

            this.downloading = true;
            let list = this.multipleSelection;
            let lines = [];
            for (let index = 0; index < list.length; index++) {
                let item = list[index];
                let line = `${this.baseUrl}${this.goYulan(item)}`;
                lines.push({ src: line, orderNO: item.orderNO });
            }
            let res = await HttpClient.post("/forward/alldownload", {
                lines,
            });
            this.downloading = false;
            for (let index = 0; index < res.result.length; index++) {
                const item = res.result[index];
                await this.downloadIamge(item.src, item.orderNO);
            }
            // let url =
            //     "http://katherine.yibaicdn.com/FqgSmPZo2Wy4xueA294AKoDgoVjv";
            // let link = document.createElement("a");
            // let res = await fetch(url);
            // let blob = await res.blob();
            // link.href = window.URL.createObjectURL(blob);
            // link.download = "1.jpeg";
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(link.href);
        },
        async downloadIamge(imgsrc, name) {
            let image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
                let canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                let context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                let url = canvas.toDataURL("image/jpeg"); //得到图片的base64编码数据
                let a = document.createElement("a"); // 生成一个a元素
                let event = new MouseEvent("click"); // 创建一个单击事件
                a.download = name || "photo"; // 设置图片名称
                a.href = url; // 将生成的URL设置为a.href属性
                a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = imgsrc;
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {};
            if (this.keyword) {
                const regex = {
                    $regex: this.keyword,
                    $options: "i",
                };
                cond["$or"] = [
                    {
                        house: {
                            $deep: {
                                model: "House",
                                cond: {
                                    name: regex,
                                },
                            },
                        },
                    },
                    {
                        purchaser0: {
                            $deep: {
                                model: "Purchaser",
                                cond: {
                                    name: regex,
                                },
                            },
                        },
                    },
                    {
                        purchaser1: {
                            $deep: {
                                model: "Purchaser",
                                cond: {
                                    name: regex,
                                },
                            },
                        },
                    },
                    {
                        purchaser2: {
                            $deep: {
                                model: "Purchaser",
                                cond: {
                                    name: regex,
                                },
                            },
                        },
                    },
                    {
                        orderNO: regex,
                    },
                    {
                        remarks: regex,
                    },
                ];
            }
            if (this.date && this.date.length) {
                let [start, end] = this.date;
                cond.date = {
                    $gte: dayjs(start).startOf("day"),
                    $lte: dayjs(end).endOf("day"),
                };
            }
            cond.status = "normal";
            let res = await HttpClient.post("/restful", {
                model: "Forward",
                cond,
                sort: {
                    _id: -1,
                },
                populate: "house purchaser0 purchaser1 purchaser2",
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.table.submitTotal(res.count);
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            await removeModel("Forward", item._id);
            msgSuccess();
            this.refetchData();
        },
        goYulan(item) {
            let house = item.house ? item.house.name : "";
            let index = 0;
            switch (house) {
                case "太仓阳鸿石化有限公司":
                    index = 0;
                    break;
                case "江苏长江石油化工有限公司":
                    index = 1;
                    break;
            }
            let orderNO = item.orderNO;
            let price = item.price;
            let purchaser0 = item.purchaser0 ? item.purchaser0.name : "";
            let tank = item.tank ? item.tank : "T";
            let purchaser1 = item.purchaser1 ? item.purchaser1.name : "";
            let purchaser2 = item.purchaser2 ? item.purchaser2.name : "";
            let count = item.count;
            let date = dayjs(item.date).format("YYYYMMDD");
            let downDate = dayjs(item.downDate).format("YYYYMMDD");
            let others = `${index}?price=${price}&house=${house}&orderNO=${orderNO}&purchaser0=${purchaser0}&purchaser1=${purchaser1}&purchaser2=${purchaser2}&count=${count}&date=${date}&downDate=${downDate}&tank=${encodeURIComponent(
                tank
            )}`;
            return `html-forwardpreview${others}`;
        },
    },
};
</script>
